export const NAME = 'consultations';